import { Show, createSignal } from "solid-js";

import { useClient } from "@revolt/client";
import { useModals } from "@revolt/modal";
import { Avatar, Symbol, UserStatus } from "@revolt/ui";
import { Tooltip } from "@revolt/ui/components/floating";

import { UserMenu } from "../servers/UserMenu";

/**
 * Majalis: profile + settings bar at the bottom of the sidebar
 * (replaces the avatar and gear that used to live in the server rail).
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function UserBar() {
  const client = useClient();
  const { openModal } = useModals();
  const [menuButton, setMenuButton] = createSignal<HTMLElement>();
  const user = (): any => client()?.user;

  return (
    <Show when={user()}>
      <div style="flex-shrink:0;display:flex;align-items:center;gap:6px;padding:8px 10px;border-top:1px solid rgba(255,255,255,0.07);">
        <Tooltip placement="top" content="Your profile and status">
          <a
            ref={setMenuButton}
            style="flex:1;min-width:0;display:flex;align-items:center;gap:10px;padding:4px 6px;border-radius:12px;cursor:pointer;"
          >
            <Avatar
              size={36}
              src={user().avatarURL}
              holepunch={"bottom-right"}
              overlay={<UserStatus.Graphic status={user().presence} />}
              interactive
            />
            <div style="min-width:0;display:flex;flex-direction:column;line-height:1.25;">
              <span style="font-size:14px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {user().displayName ?? user().username}
              </span>
              <span style="font-size:12px;opacity:0.65;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                {user().presence}
              </span>
            </div>
          </a>
          <UserMenu anchor={menuButton} />
        </Tooltip>
        <Tooltip placement="top" content="Your account settings">
          <a
            aria-label="Account settings"
            onClick={() => openModal({ type: "settings", config: "user" })}
            style="flex-shrink:0;display:flex;align-items:center;gap:6px;padding:7px 12px;border-radius:999px;border:1px solid rgba(255,255,255,0.14);cursor:pointer;font-size:12px;font-weight:600;"
          >
            <Symbol>manage_accounts</Symbol>
            <span>Settings</span>
          </a>
        </Tooltip>
      </div>
    </Show>
  );
}
